require.config({
    waitSeconds: 120,
    shim: {
        'device': {
            exports: 'device'
        },
        'event-manager': {
            deps: ['jquery']
        },
        'royalslider': {
            deps: ['jquery']
        },
        'highcharts': {
            deps: ['jquery']
        },
        'jquery.lazyload': ['jquery'],
        'svp-player': {
            'exports': 'SVP.Player'
        },
        'react': {
            exports: 'React'
        },
        'finn-carousel': {
            exports: 'FINNExternalDistribution'
        },
    },
    paths: {
        'jquery': '//e24.vgc.no/cdn/js/vendor/jquery-3.1.1.min',
        'device': '../../bower_components/device/dist/devicejs.min',
        'highcharts': '../../bower_components/highcharts/highcharts',
        'royalslider': '//e24.vgc.no/cdn/js/vendor/jquery.royalslider.min',
        'Engage': '//engage-cdn.schibsted.media/js/sdk/v6/engage-sdk.min.js.gz?noext',
        'pulse2': 'https://sdk.pulse.schibsted.com/loader-modern.min.js',
        'jsx': '../../bower_components/jsx-requirejs-plugin/js/jsx',
        'JSXTransformer': '../../bower_components/jsx-requirejs-plugin/js/JSXTransformer',
        'react': '../../bower_components/react/react-with-addons',
        'text': '../../bower_components/text/text',
        'classnames': '../../bower_components/classnames/index',
        'swiper': '../../bower_components/swiper/dist/js/swiper.min',
        'EventEmitter': '../../bower_components/eventEmitter/EventEmitter.min',
        'pym': '../../bower_components/pym.js/dist/pym.min',
        'lib': 'lib',
        'finn-carousel': 'finn-carousel',
        'underscore': '../../bower_components/lodash/lodash.min',
        'event-manager': '../../bower_components/event-manager/src/event-manager.min',
        'svp-player': '//svp.vgc.no/js/svp.sdk-0.9.latest.min',
        'svp': '../../bower_components/svp/src/svp.min'
    },
    jsx: {
        fileExtension: '.jsx'
    }
});

require([
    // deps
    'jquery',
    'underscore',
    'event-manager',
    'lib',

    // core
    'dispatcher',
    'app',
    'ads/index',
    'header',
    'widgets',
    'tracking',

    // pages
    'front',
    'podcast',
    'tpn',
    'rss',
    'lunch',
    'contact',
    'notfound',
], function() {
    'use strict';
});

define("main", function(){});

